// eslint-disable-next-line import/prefer-default-export
export const USER_RIGHT_TYPES = {
  COMMON: 'COMMON',
  ACCOUNTING: 'ACCOUNTING',
  CUSTODIAN: 'CUSTODIAN',
  AUDITOR: 'AUDITOR',
  COMPLIANCE_OFFICER: 'COMPLIANCE_OFFICER',
  REFERRAL_PARTNER: 'REFERRAL_PARTNER',
  ADMIN: 'ADMIN',
  GENERAL_ADMIN: 'GENERAL_ADMIN',
}

export const USER_RIGHTS_WEIGHT = {
  [USER_RIGHT_TYPES.COMMON]: 1,
  [USER_RIGHT_TYPES.ACCOUNTING]: 1.8,
  [USER_RIGHT_TYPES.CUSTODIAN]: 1.5,
  [USER_RIGHT_TYPES.AUDITOR]: 1.6,
  [USER_RIGHT_TYPES.REFERRAL_PARTNER]: 1.75,
  [USER_RIGHT_TYPES.COMPLIANCE_OFFICER]: 2,
  [USER_RIGHT_TYPES.ADMIN]: 3,
  [USER_RIGHT_TYPES.GENERAL_ADMIN]: 4,
}

export const USER_STATUS_TYPES = {
  DELETED: 'DELETED',
  BLOCKED: 'BLOCKED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

export const USER_KYC_STATUS_TYPES = {
  NOT_SUBMITTED: 'NOT_SUBMITTED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  PASSED: 'PASSED',
  REOPEN: 'REOPEN',
}

export const USER_VIDEO_IDENT_STATUS = {
  NOT_NEEDED: 'NOT_NEEDED',
  PENDING: 'PENDING',
  PASSED: 'PASSED',
  DENIED: 'DENIED',
  NOT_STARTED: 'NOT_STARTED'
}
